<template>
	<div class="blockItem">
		<div class="blockBody">
			<div class="blockTitle">
				<div class="blockTitleL">学校概览</div>
				<!-- <div class="blockTitleR">66666</div> -->
			</div>
			<div class="schOverview">
				<div class="item borderRight">
					<div class="itemTitle item1">
						<div class="itemTitleL">
							<div class="icon"><i class="iconfont icon-school"></i></div>
							<div class="txt">
								<div class="txtTitle">学校数量</div>
								<div class="txtNum">
									<!-- {{$utils.outputdollars(149)}} -->
									<countTo :startVal='0' :endVal='149' :duration='2000'></countTo>
								</div>
							</div>
						</div>
					</div>
					<div class="itemContent">
						<div class="option">
							<div class="optionTitle">幼儿园数</div>
							<div class="optionNum">{{$utils.outputdollars(60)}}</div>
						</div>
						<div class="option optionR">
							<div class="optionTitle">小学数</div>
							<div class="optionNum">{{$utils.outputdollars(47)}}</div>
						</div>
						<div class="option">
							<div class="optionTitle">初中数</div>
							<div class="optionNum">{{$utils.outputdollars(33)}}</div>
						</div>
						<div class="option optionR">
							<div class="optionTitle">高中数</div>
							<div class="optionNum">{{$utils.outputdollars(12)}}</div>
						</div>
					</div>
				</div>
				<div class="item">
					<div class="itemTitle item2">
						<div class="itemTitleL">
							<div class="icon"><i class="iconfont icon-teacher"></i></div>
							<div class="txt">
								<div class="txtTitle">教师数量</div>
								<div class="txtNum">
									<!-- {{$utils.outputdollars(7169)}} -->
									<countTo :startVal='0' :endVal='7169' :duration='2000'></countTo>
								</div>
							</div>
						</div>
						<div class="itemTitleR">
							<div>男&nbsp;&nbsp;{{$utils.outputdollars(1894)}}</div>
							<div>女&nbsp;&nbsp;{{$utils.outputdollars(5275)}}</div>
						</div>
					</div>
					<div class="itemContent">
						<div class="option">
							<div class="optionTitle">幼儿园人数</div>
							<div class="optionNum">{{$utils.outputdollars(2873)}}</div>
						</div>
						<div class="option optionR">
							<div class="optionTitle">小学人数</div>
							<div class="optionNum">{{$utils.outputdollars(1561)}}</div>
						</div>
						<div class="option">
							<div class="optionTitle">初中人数</div>
							<div class="optionNum">{{$utils.outputdollars(1379)}}</div>
						</div>
						<div class="option optionR">
							<div class="optionTitle">高中人数</div>
							<div class="optionNum">{{$utils.outputdollars(1356)}}</div>
						</div>
					</div>
				</div>
				<div class="item borderRight">
					<div class="itemTitle item3">
						<div class="itemTitleL">
							<div class="icon"><i class="iconfont icon-class"></i></div>
							<div class="txt">
								<div class="txtTitle">班级数量</div>
								<div class="txtNum">
									<!-- {{$utils.outputdollars(2587)}} -->
									<countTo :startVal='0' :endVal='2587' :duration='2000'></countTo>
								</div>
							</div>
						</div>
					</div>
					<div class="itemContent">
						<div class="option">
							<div class="optionTitle">幼儿园班级数</div>
							<div class="optionNum">{{$utils.outputdollars(935)}}</div>
						</div>
						<div class="option optionR">
							<div class="optionTitle">小学班级数</div>
							<div class="optionNum">{{$utils.outputdollars(587)}}</div>
						</div>
						<div class="option">
							<div class="optionTitle">初中班级数</div>
							<div class="optionNum">{{$utils.outputdollars(536)}}</div>
						</div>
						<div class="option optionR">
							<div class="optionTitle">高中班级数</div>
							<div class="optionNum">{{$utils.outputdollars(529)}}</div>
						</div>
					</div>
				</div>
				<div class="item">
					<div class="itemTitle item4">
						<div class="itemTitleL">
							<div class="icon"><i class="iconfont icon-students"></i></div>
							<div class="txt">
								<div class="txtTitle">学生数量</div>
								<div class="txtNum">
									<!-- {{$utils.outputdollars(91536)}} -->
									<countTo :startVal='0' :endVal='91536' :duration='2000'></countTo>
								</div>
							</div>
						</div>
						<div class="itemTitleR">
							<div>男&nbsp;&nbsp;{{$utils.outputdollars(55227)}}</div>
							<div>女&nbsp;&nbsp;{{$utils.outputdollars(36309)}}</div>
						</div>
					</div>
					<div class="itemContent">
						<div class="option">
							<div class="optionTitle">幼儿园人数</div>
							<div class="optionNum">{{$utils.outputdollars(28050)}}</div>
						</div>
						<div class="option optionR">
							<div class="optionTitle">小学人数</div>
							<div class="optionNum">{{$utils.outputdollars(23468)}}</div>
						</div>
						<div class="option">
							<div class="optionTitle">初中人数</div>
							<div class="optionNum">{{$utils.outputdollars(20981)}}</div>
						</div>
						<div class="option optionR">
							<div class="optionTitle">高中人数</div>
							<div class="optionNum">{{$utils.outputdollars(19037)}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import countTo from 'vue-count-to'
	export default {
		components: {
			countTo,
		},
	}
</script>

<style lang="less" scoped>
	.schOverview {
		width: 100%;
		height: calc(100% - 68px);
		display: flex;
		flex-wrap: wrap;
		align-content: flex-start;
		.item {
			width: calc(50% - 64px);
			height: 50%;
			flex: 0 0 calc(50% - 64px);
			padding: 0 32px;
			.itemTitle {
				display: flex;
				justify-content: space-between;
				.itemTitleL {
					display: flex;
					.icon {
						margin-right: 16px;
						i {
							font-size: 48px;
						}
					}
					.txt {
						.txtTitle {
							color: rgba(255, 255, 255, 0.6);
							font-size: 18px;
							margin-bottom: 4px;
						}
						.txtNum {
							font-size: 30px;
							font-weight: bold;
						}
					}
				}
				.itemTitleR {
					font-size: 18px;
					div:first-child {
						margin-bottom: 12px;
					}
				}
				&.item1 {
					i {
						color: #fbdc50;
					}
					.txtNum {
						color: #fbdc50;
					}
				}
				&.item2 {
					i {
						color: #0ac2d6;
					}
					.txtNum {
						color: #0ac2d6;
					}
				}
				&.item3 {
					i {
						color: #ffb400;
					}
					.txtNum {
						color: #ffb400;
					}
				}
				&.item4 {
					i {
						color: #13d363;
					}
					.txtNum {
						color: #13d363;
					}
				}
			}
			.itemContent {
				display: flex;
				flex-wrap: wrap;
				align-content: flex-start;
				.option {
					padding: 12px 0;
					width: 50%;
					flex: 0 0 50%;
					// text-align: center;
					.optionTitle {
						color: rgba(255, 255, 255, 0.4);
						font-size: 16px;
						margin-bottom: 2px;
					}
					.optionNum {
						font-size: 26px;
					}
					&.optionR {
						text-align: right;
					}
				}
			}
		}
	}
</style>
